export const isDefaultNotification = () => {
  return Notification.permission === 'default';
};

export const isGrantedNotification = () => {
  return Notification.permission === 'granted';
};

export const requestNotificationPermission = () => {
  return new Promise((resolve, reject) =>
    Notification.requestPermission()
      .then(permission => {
        if (permission === 'granted') {
          resolve(permission);
        } else {
          reject(permission);
        }
      })
      .catch(reject),
  );
};
